import React from "react";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const DueDateRangeFilterLabel: React.FC<Props> = ({ filters }) => {
    const { dueDateStart, dueDateEnd } = filters;

    if (!dueDateStart && !dueDateEnd) {
        return null;
    }

    if (dueDateStart && dueDateEnd) {
        return (
            <span>
                {dueDateStart.toLocaleDateString()} -{" "}
                {dueDateEnd.toLocaleDateString()}
            </span>
        );
    }

    if (dueDateStart) {
        return <span>From {dueDateStart.toLocaleDateString()}</span>;
    }

    if (dueDateEnd) {
        return <span>Until {dueDateEnd.toLocaleDateString()}</span>;
    }

    return null;
};
